import axios from 'axios';
import AuthService from '../services/authService';
import { getURL } from '../services/GeneralServices';

const axiosInstance = axios.create({
  baseURL: getURL(),
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const apiKey = AuthService.getApiKey();
    if (apiKey) {
      config.headers['x-api-key'] = apiKey;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// The student stays signed in indefinitely (the api key itself doesn't
// expire client-side) -- this only fires once the backend actually rejects
// the key (missing / invalid / past its server-side TTL), so login is only
// asked for again when the session has genuinely ended.
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const isLoginRequest = String(error?.config?.url || '').includes('/students/login');
    if (status === 401 && !isLoginRequest) {
      AuthService.clear();
      if (window.location.pathname !== '/login') {
        AuthService.flagSessionExpired();
        window.location.replace('/login');
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
